import { Options, Vue } from "vue-class-component";
import Checkbox from "primevue/checkbox";
import { appAxios } from "@/core/utils/appAxios";
import { APIResponse, OrderDto } from "@/shared/api-contract/api-contract";
import { Emit, Model } from "vue-property-decorator";
import PdfApp from "vue3-pdf-app";
import "vue3-pdf-app/dist/icons/main.css";
import { watch } from "vue";

@Options({
    components: {
        Checkbox,
        PdfApp,
    },
})
export class ProformaPopup extends Vue {
    @Model("_order", { required: true })
    order!: OrderDto;

    pdf = "";
    pdfConfig = {
        toolbar: {
            toolbarViewerLeft: true,
            toolbarViewerRight: false,
            toolbarViewerMiddle: {
                zoomOut: true,
                zoomIn: true,
                scaleSelectContainer: false, // TODO show dependin on width
            },
        },
    };

    pagesRendered(pdfApp) {
        setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-height"));
    }
    isAgree = false;

    @Emit("close")
    closePopup() {
        this.$emit("close");
        URL.revokeObjectURL(this.pdf);
    }

    mounted() {
        this.fetchProformaDocument(this.order.id.toString());
    }

    /* API Connectivity --------------------------------------------------------------------------------------------- */
    fetchProformaDocument = async (id: number | string) => {
        if (!id) return;
        appAxios.value
            .get<Blob>(`/client/web/orders/${id}/proforma-document`, {
                headers: {
                    accept: "application/pdf",
                },
                responseType: "blob",
            })
            .then((response) => {
                const objectUrl = URL.createObjectURL(response.data);
                this.pdf = objectUrl;
            })
            .catch((res) => {
                console.log(`Fetch Proforma Document for Order #${id} error:`, res);
            });
    };
}
